import React, { useEffect, useState } from 'react'
import TableComponent from '../CustomComponents/TableComponent'
import PageHeader from '../../view/pageheader'
import { Button, Card, DatePicker, Divider, Form, Modal, Select, Typography } from 'antd'
import SearchComponent from '../CustomComponents/SearchComponent'
import { getJobInspectionReport, getJobsList } from '../../store/reducer/jobSlice'
import { getCustomerList } from '../../store/reducer/customerSlice'
import { getEventList } from '../../store/reducer/eventSlice'
import { getUserGroupList } from '../../store/reducer/userGroupSlice'
import { getUserManagementList } from '../../store/reducer/userManagementSlice'
import { useDispatch, useSelector } from 'react-redux'


const JobInspection = () => {
    const dispatch = useDispatch();
    const { getJobInspectionReportData, jobListData } = useSelector((state) => state.jobs);
    const { customerListData } = useSelector((state) => state.customers);
    const { eventListData } = useSelector((state) => state.events);
    const { userGroupListData } = useSelector((state) => state.userGroups)
    const { userManagementListData } = useSelector((state) => state.userManagement)
    const { Text } = Typography;
    const [newModalOpen, setNewModal] = useState(false);
    const { data: tableData } = getJobInspectionReportData
    const onFinish = values => {

    };
    const [form] = Form.useForm();
    function getData(payload = {}) {
        dispatch(getJobInspectionReport({ payload }));
        dispatch(getJobsList({ payload }));
        dispatch(getCustomerList({ payload }));
        dispatch(getEventList({ payload }));
        dispatch(getUserGroupList({}))
        dispatch(getUserManagementList({}))
    }
    useEffect(() => {
        getData({});
    }, [])
    const specIdData = jobListData.data?.filter((data) => data.status != 0).map((item) => ({
        label: item?.spec_id,
        value: item?.id
    }))
    const customerData = customerListData.data?.filter((data) => data.status != 0).map((item) => ({
        label: item?.customername,
        value: item?.id
    }))
    const eventData = eventListData.data?.filter((data) => data.status != 0).map((item) => ({
        label: item?.eventname,
        value: item?.id
    }))
    const userGroupData = userGroupListData?.data?.filter((data) => data.status != 0).map((item) => ({
        label: item.user_group_name,
        value: item.id
    }))
    const usersData = userManagementListData?.data?.filter((data) => data.status != 0 && data?.role_id == 3).map((item) => ({
        label: item.user_name,
        value: item.id
    }))
    const columns = [
        {
            title: 'Users',
            dataIndex: 'user_name',
            key: 'user_name',
            align: 'center',
        },
        {
            title: 'Boxes Processed',
            dataIndex: 'record_count',
            key: 'record_count',
            align: 'center',
        },
        {
            title: 'Total Time (hours)',
            dataIndex: 'total_time',
            key: 'total_time',
            align: 'center',

        },

        {
            title: 'Avg. Time / Box',
            dataIndex: 'avg_time_per_box',
            key: 'avg_time_per_box',
            align: 'center',


        },



    ]



    return (
        <>
            <>
                <PageHeader HeaderText="Job Inspection Report" Breadcrumb={[{ name: "Job Inspection Report" }]} />
                 <Card style={{ marginTop: "-28px", }} title={'Job Performance Report'}
                    extra={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                gap: "12px",
                                margin: "16px 0"
                            }}
                        >

                            {/* Left Side: Search + Buttons */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexWrap: "wrap"
                                }}
                            >
                                <Button className="primary-btn rounded-4" onClick={() => setNewModal(true)}>
                                    Filter Report
                                </Button>
                                <SearchComponent
                                    style={{ width: "300px" }}
                                    placeHolder="Search Box Number"
                                />
                                <Button className="primary-btn rounded-4">
                                    Search Box Number
                                </Button>
                            </div>
                        </div>
                    }
                >



                    <div style={{ fontWeight: 700, fontSize: '15px', marginRight: '450px' }}>Users Detailed Breakdown</div>

                    <TableComponent columns={columns} TotalDataCount={tableData?.length} dataSource={tableData} size={"small"} />
                    <Modal
                        open={newModalOpen}
                        onCancel={() => setNewModal(false)}
                        footer={null}
                    >
                        <Form
                            form={form}
                            layout="inline"
                            onFinish={onFinish}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                                padding: "8px 0",
                                flexWrap: "wrap", // keeps it responsive
                            }}
                        >
                            {/* Customer Dropdown */}
                            <Form.Item
                                name="customer"
                                label={<Text strong>Customer </Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={customerData} placeholder="Select Customer" style={{ width: 180, marginLeft: '20px' }} />
                            </Form.Item>

                            {/* Spec ID Dropdown */}
                            <Form.Item
                                name="spec_id"
                                label={<Text strong>Spec ID</Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={specIdData} placeholder="Select Spec ID" style={{ width: 180, marginLeft: '30px' }} />
                            </Form.Item>

                            {/* Date Picker */}
                            <Form.Item
                                name="date_in"
                                label={<Text strong>Date</Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <DatePicker style={{ width: 180, marginLeft: '50px' }} />
                            </Form.Item>

                            {/* Event Stage */}
                            <Form.Item
                                name="event_stage"
                                label={<Text strong>Event Stage</Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={eventData} placeholder="Select Event Stage" style={{ width: 180, marginLeft: '5px' }} />

                            </Form.Item>

                            {/* User Groups */}
                            <Form.Item
                                name="user_group"
                                label={<Text strong>User Group</Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={userGroupData} placeholder="Select User Group" style={{ width: 180, marginLeft: '10px' }} />
                            </Form.Item>
                            <Form.Item
                                name="user_name"
                                label={<Text strong>User Name</Text>}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={usersData} placeholder="Select User Name" style={{ width: 180, marginLeft: '10px' }} />
                            </Form.Item>
                            <br />
                            {/* Submit Button */}
                            <Form.Item style={{ marginBottom: 0 }}>
                                <Button type="primary" htmlType="submit">
                                    Generate Report
                                </Button>
                            </Form.Item>
                        </Form>
                    </Modal>

                    <Divider />
                    {/* <div style={{ margin: "20px 0" }}>
                        <Bar data={chartData} options={barOptions} />
                    </div>

                    <div style={{ margin: "20px 0", width: "50%", marginInline: "auto" }}>
                        <Pie data={chartData} options={pieOptions} />
                    </div> */}
                </Card >


            </>
        </>
    )
}

export default JobInspection